import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { downgradeInjectable } from '@angular/upgrade/static';

// Third-party modules
import { ColorSketchModule } from 'ngx-color/sketch';
import { NgxPopperModule } from 'ngx-popper';

// Shared modules
import { SharedModule } from '../shared';
import { UIModule } from '../ui.module';
import { ToastrModule } from '../toastr.module';
import { SharedDialogsModule } from '../shared-dialogs.module';
import { SharedServicesModule } from '../shared-services.module';

// Module's pages components.
import { DecorationComponent } from './decoration.component';
import { DecorationFigureComponent } from './decoration-figure.component';
import { DecorationDescriptionComponent } from './decoration-description.component';
import { DecorationRoomsSelectComponent } from './decoration-rooms-select.component';
import { DecorationRoomPositionComponent } from './decoration-room-position.component';
import { DecorationSettingsComponent } from './decoration-settings.component';
import { DecorationPixelizationComponent } from './decoration-pixelization.component';
import { DecorationPixelizationFormComponent } from './decoration-pixelization-form.component';
import { DecorationPixelizationListComponent } from './decoration-pixelization-list.component';
import { DecorationPixelizationListItemComponent } from './decoration-pixelization-list-item.component';
import { ScreepsRoomComponent } from './screeps-room.component';

import { DlgDecorationComponent } from './dlg-decoration';
import { ShowDlgDecorationDirective } from './show-dlg-decoration.directive';

import { ShowDlgDecorationService } from './show-dlg-decoration.service';
import { WorldConfigService } from './world-config.service';

import { UserRoomsService } from './user-rooms.service';

import { DecorationTypePipe } from './decoration-type.pipe';
import { FindRoomPipe } from './find-room.pipe';
import { FilterPropsPipe } from './filter-props.pipe';
import { ColorPropValuePipe } from './color-prop-value.pipe';
import { ColorPropFormatPipe } from './color-prop-format.pipe';

import { UserRoomObjectsDirective } from './user-rooms-objects.directive';

@NgModule({
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatChipsModule,
        MatSelectModule,
        MatSliderModule,
        MatFormFieldModule,
        RouterModule,
        ReactiveFormsModule,
        // Third-party modules
        ColorSketchModule,
        NgxPopperModule.forRoot({
            disableDefaultStyling: true,
            placement: 'bottom'
        }),
        // Shared modules
        // CoreModule,
        SharedModule,
        UIModule,
        ToastrModule,
        SharedDialogsModule,
        SharedServicesModule,
        // Current module imports
    ],
    declarations: [
        // Section Components
        DecorationComponent,
        DecorationFigureComponent,
        DecorationDescriptionComponent,
        DecorationRoomsSelectComponent,
        DecorationRoomPositionComponent,
        DecorationSettingsComponent,
        DecorationPixelizationComponent,
        DecorationPixelizationFormComponent,
        DecorationPixelizationListComponent,
        DecorationPixelizationListItemComponent,
        DlgDecorationComponent,
        ScreepsRoomComponent,

        DecorationTypePipe,
        FindRoomPipe,
        FilterPropsPipe,
        ColorPropValuePipe,
        ColorPropFormatPipe,

        ShowDlgDecorationDirective,
        UserRoomObjectsDirective,
    ],
    exports: [
        DecorationComponent
    ],
    providers: [
        WorldConfigService,
        UserRoomsService,

        ShowDlgDecorationService
    ],
    entryComponents: [
        DlgDecorationComponent
    ]
})
export class DlgDecorationModule { }

declare const angular: angular.IAngularStatic;

angular.module('app')
    .factory('ShowDlgDecorationService', downgradeInjectable(ShowDlgDecorationService) as any);
